import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { BaseObject } from './BaseObject';
import { getCalendarPosition, CalendarPosition } from '../misc/calendarPosition';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
 */

export const MissionStatus = {
    None: 0,
    Active: 1,
    Historic: 2,
    ActiveOrHistoric: 3,
    Future: 4,
    ActiveOrFuture: 5,
    HistoricOrFuture: 6,
    All: 7,
};

export class Mission extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);

            this.Start = utility.parseDate(this.Start);
            this.End = utility.parseDate(this.End);

            this.calendarPosition = getCalendarPosition(this.Start, this.End);
            this.Active = this.calendarPosition === CalendarPosition.Active || this.calendarPosition === CalendarPosition.Future;
        }
    }

    static createPlaceholder(order) {
        var ret = new Mission();
        ret._placeholder = true;
        ret.OrderNumber = order;
        return ret;
    }

    isPlaceholder() {
        return !!this._placeholder;
    }

    /**
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        this.Person = ctx.getPerson(this.PersonId);
        this.MandatePeriod = ctx.getMandatePeriod(this.MandatePeriodId);
        this.Party = ctx.getParty(this.PartyId);
        this.MissionType = ctx.getMissionType(this.MissionTypeId);
        this.Substitutes = ctx.getPerson(this.SubstituteIds);
        this.Divisions = ctx.getDivision(this.DivisionIds);
    }

    toJSON() {
        var ret = super.toJSON();
        ret.PersonId = BaseObject.withRelated(ret, "Person");
        ret.MandatePeriodId = BaseObject.withRelated(ret, "MandatePeriod");
        ret.PartyId = BaseObject.withRelated(ret, "Party");
        ret.MissionTypeId = BaseObject.withRelated(ret, "MissionType");

        ret.SubstituteIds = BaseObject.withRelated(ret, "Substitutes");
        ret.DivisionIds = BaseObject.withRelated(ret, "Divisions");
        return ret;
    }
}
